import React from 'react';

import { observer } from 'mobx-react-lite';

import buttonCoins from '../../../assets/images/game/coins.svg';

const AutoCashOut = observer(
  ({
    betId,
    isDisabled,
    autoCashOutOdd,
    handleOpenPopUp,
    isNextRoundAutoCashOut,
    setAutoCashOutOddPopupId,
  }) => {
    return (
      <button
        type='button'
        onClick={(event) => handleOpenPopUp(event, setAutoCashOutOddPopupId)}
        className={`c-m-bets-btn type-${
          betId && autoCashOutOdd && !isNextRoundAutoCashOut ? 2 : 1
        } ${isDisabled ? 'disabled' : ''}`}
      >
        {autoCashOutOdd ? (
          <span className='c-m-bets-btn-txt'>x{autoCashOutOdd}</span>
        ) : (
          <img className='c-m-bets-btn-img' src={buttonCoins} alt='' />
        )}
        <span className='c-m-bets-btn-hover' />
        <span className='c-m-bets-btn-line' />
      </button>
    );
  }
);

export default AutoCashOut;
